<template>
  <ServicePageLayout
    title="ตู้แช่ยา"
    subtitle="ระบบติดตามอุณหภูมิตู้แช่ยา (ช่วงปลอดภัย 2-8 °C)"
    icon="mdi-fridge-industrial"
    icon-color="info"
    breadcrumb="Operations"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Dashboard</v-tab>
      <v-tab>History</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MedicineRefrigeratorDashboard /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MedicineRefrigeratorHistory /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import MedicineRefrigeratorDashboard from '@/components/medicine_refrigerator/medicine_refrigerator_dashboard.vue'
import MedicineRefrigeratorHistory from '@/components/medicine_refrigerator/medicine_refrigerator_history.vue'

export default {
  name: 'MedicineRefrigeratorView',
  components: {
    ServicePageLayout,
    MedicineRefrigeratorDashboard,
    MedicineRefrigeratorHistory
  },
  data() {
    return { tab: null }
  }
}
</script>
